module.exports = __webpack_public_path__ + "static/media/u2705.6bc5cdb9.webp";